import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Template from "../DataTable/loading";
const Skeleton = () => {
  return (
    <>
      <div
        className={tw`w-full bg-white p-4 rounded-md mb-8`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      ></div>
      <Template addNewPath={true} />
    </>
  );
};

export default Skeleton;
